import {
    SimpleShowLayout,
    TextField,
    usePermissions,
    useResourceContext,
    FunctionField,
    useTranslate,
    TabbedShowLayout,
    Tab,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { RaShowView } from "shared/src/components/views/RaShowView";
import { MediaManagement } from "../components/media/MediaManagement";

export const DamageReportShow = (props) => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const translate = useTranslate();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaShowView {...props} actions={<ToolbarWithHistory back={true} edit={true} />}>
            <SimpleShowLayout>
                <TextField label="equip.title" source="title" />
                <RaDateField label="equip.date" source="date" />
                <TextField label="equip.damageDescription" source="damageDescription" />
                <TextField label="equip.incidentDescription" source="incidentDescription" />
                <TextField label="equip.remarks" source="remarks" />
                <TextField label="equip.sku" source="sku.labelNumber" />
                <TextField label="equip.rental" source="rental.name" />
                <TextField label="equip.responsibleUser" source="responsibleUser.email" />
                <FunctionField
                    label="equip.status"
                    render={(record) => translate(`equip.damageReportStatus_${record.status}`)}
                />
                <TabbedShowLayout sx={{ mb: 5 }}>
                    <Tab label="equip.media" title={translate("equip.media")}>
                        <MediaManagement resourceFilterKey="damageReport" />
                    </Tab>
                </TabbedShowLayout>
            </SimpleShowLayout>
        </RaShowView>
    );
};
